import getTheme from './getTheme';
import { getIsDarkTheme } from 'owa-fabric-theme';
import shouldUseCobranding from './shouldUseCobranding';
import { ThemeConstants } from 'owa-theme-shared';

export default function getIsLightBaseTheme(): boolean {
    let theme = getTheme();
    let isDarkTheme = getIsDarkTheme();
    return (
        !isDarkTheme &&
        (theme === ThemeConstants.BASE_OFFICE_THEME_ID ||
            (theme == ThemeConstants.BASE_THEME_ID && !shouldUseCobranding(theme, isDarkTheme)))
    );
}
